import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { DocumentEmailService } from '../../services/document-email.service';
import { ToastrService } from 'ngx-toastr';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { NgSwitch, NgSwitchCase, NgIf } from '@angular/common';

@Component({
  selector: 'app-email-document-to-customer-dialog',
  templateUrl: './email-document-to-customer-dialog.component.html',
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase,
    NgIf,
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatError,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class EmailDocumentToCustomerDialogComponent {
  email = new FormControl<string>(null, [
    Validators.email,
    Validators.required
  ]);
  submitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private documentEmailService: DocumentEmailService,
    private dialog: MatDialogRef<EmailDocumentToCustomerDialogComponent>,
    private toastrService: ToastrService
  ) {
    this.email.setValue(data.customer.email);
  }

  submit() {
    this.submitting = true;
    this.documentEmailService
      .email({
        type: this.data.documentType,
        documentId: this.data.documentId,
        email: this.email.value
      })
      .subscribe({
        complete: () => this.onSuccess(),
        error: () => this.onError()
      });
  }

  private onError() {
    this.submitting = false;
    this.toastrService.error('Failed to send email');
  }

  private onSuccess() {
    this.dialog.close();
    this.toastrService.success('Email sent');
  }
}
